import useIsTouchScreenDevice from '../use-is-touch-screen-device';
import useWindowSize from '../use-window-size';
export default function useResponsive() {
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width,
    loaded = _useWindowSize.loaded;
  var _useIsTouchScreenDevi = useIsTouchScreenDevice(),
    isTouchScreenDevice = _useIsTouchScreenDevi.isTouchScreenDevice;
  return {
    isMobile: !width || width <= 767,
    isTablet: width >= 768 && width <= 991,
    isSmallMonitor: width >= 992 && width <= 1199,
    isLargeMonitor: width >= 1200 && width <= 1919,
    isWideScreenMonitor: width >= 1920,
    isSmallScreen: !width || width <= 991,
    isDesktop: width >= 992,
    loaded: loaded,
    isTouchScreenDevice: isTouchScreenDevice
  };
}